/**
 *      culguraGlistado.js
 *          Script de culturaGlistado.vue
 *          Obtiene los casos de evaluación ya registrados permitiendo editarlos y eliminarlos
 */
/* ======================================================================================================== */    

import M from 'materialize-css'

import moment           from 'moment'    
import ingreso          from './ingreso.vue'
import casosxEmpresa    from './culturaGCasosTotal.vue'
import pagineo          from './culturaGPagineo.vue'

import {store}          from './../store/store'

// import 'materialize-css/dist/css/materialize.min.css'

export default {
    name: 'listadoencuesta',
    components:{
        'moment': moment,
        'input-date': ingreso,
        casosxEmpresa,
        pagineo,
    },
    template:  `#listadoEncuesta`,        
    data(){
        return{
            casos: [],
            casos_copia: null,              // Necesario  una copia para borrar una encuesta después buscar por Descripción o Responsable.

            busqueda: "", busquedaR: "",    // Variables para la búsqueda}
            lfuente: "C",
        } // return
    }, // data()
    mounted(){
        
        /** Definiciones para el uso de las secciones tipo slide y tooltips */
        var elems = document.querySelectorAll('.collapsible');
        var instances = M.Collapsible.init(elems, {});            

        var elems = document.querySelectorAll('.tooltipped');
        var instances = M.Tooltip.init(elems, {});          

        this.bdRead();                          // CAMBIO 2: Leyendo la info de FireBase.
        // this.bdReadMem();        
    },
    computed: {
        lc_ini(){
            return store.state.Clini;
        },
        lc_fin(){
            return store.state.Clfin;
        },
        c_pagina(){
            return store.state.Cpagina;
        },      
filtrarCasos: function() {
            return this.casos.filter( (caso) => {
                
                /* Preserva el índice las tareas recién instanciadas ya que cuando se realiza una búsqueda y se quiere 
                   eliminar una tarea, el índice cambia y borra otra tarea. [ Ver función eliminar() ] en tareas.vue.  */
                if (caso.empresa.toUpperCase().includes(this.busqueda.toUpperCase()) && caso.nombre.toUpperCase().includes(this.busquedaR.toUpperCase())) {
                    return caso
                }
            })
        }, // filtarTareas()
    },
    methods:{
        eliminarCaso(elCaso,index){
            
            var confirma = confirm("Seguro de eliminar la evaluación de "+elCaso.nombre.trim()+" ? "+index+")");
            if (confirma === true){

                var lnuevaRuta  = store.state.st_rutaCasos + "/" + index;
                var dbCasos     = store.state.st_db.ref(lnuevaRuta);

                var elRegTarea  = dbCasos.remove();
            }
        },
        mostrarCaso(elcaso){

            store.state.st_modo = "EDITAR"
            store.state.st_caso = elcaso;
            // console.log("[culturaGlistado- mostrarEncuesta], modo ? ",store.state.st_modo,", ",store.state.st_caso);
            // console.log("[culturaGlistado- mostrarEncuesta], nombre ? ",store.state.st_caso.nombre);

            //this.$refs.email.$el.focus()
            // culturaG.$refs.testt1.$el.focus();
        },
        /* ========================================================================================================= */            
        getCasos(losCasos){
                    
            // console.log("[culturaGlistado.js- getCasos], losCasos ? ",losCasos);
            // console.log("[culturaGlistado.js- getCasos], casos antes ? ",this.casos);
            this.casos = [];
            // console.log("[culturaGlistado.js- getCasos], casos despues ? ",this.casos);

            for (let key in losCasos){

                // console.log("[culturaGlistado.js]-getCasos(), key: ",key,"; codigo ? ",losCasos[key].empresa,"; nombre ? ",losCasos[key].nombre);
                this.casos.push({

                    llave: key,                                             // 1
                    empresa: losCasos[key].empresa, 
                    nombre: losCasos[key].nombre, 
                    g1pg1: losCasos[key].g1pg1, g1pg2: losCasos[key].g1pg2, g1pg3: losCasos[key].g1pg3, g1pg4: losCasos[key].g1pg4,
                    g2pg1: losCasos[key].g2pg1, g2pg2: losCasos[key].g2pg2, g2pg3: losCasos[key].g2pg3, g2pg4: losCasos[key].g2pg4,
                    g3pg1: losCasos[key].g3pg1, g3pg2: losCasos[key].g3pg2, g3pg3: losCasos[key].g3pg3, g3pg4: losCasos[key].g3pg4,
                    g4pg1: losCasos[key].g4pg1, g4pg2: losCasos[key].g4pg2, g4pg3: losCasos[key].g4pg3, g4pg4: losCasos[key].g4pg4,
                    g5pg1: losCasos[key].g5pg1, g5pg2: losCasos[key].g5pg2, g5pg3: losCasos[key].g5pg3, g5pg4: losCasos[key].g5pg4,
                    g6pg1: losCasos[key].g6pg1, g6pg2: losCasos[key].g6pg2, g6pg3: losCasos[key].g6pg3, g6pg4: losCasos[key].g6pg4,
                    r1suma: losCasos[key].r1suma, r2suma: losCasos[key].r2suma, r3suma: losCasos[key].r3suma, r4suma: losCasos[key].r4suma,
                    r1prom: losCasos[key].r1prom, r2prom: losCasos[key].r2prom, r3prom: losCasos[key].r3prom, r4prom: losCasos[key].r4prom,
                })
            } // for

            this.limite=        this.casos.length; // cantidad de datos                
            this.casos_copia=   this.casos;    

            // console.log("[culturaGlistado.js- getCasos], st_casos antes ? ",store.state.st_casos);
            store.state.st_casos= this.casos;
            // console.log("[culturaGlistado.js- getCasos], st_casos despues ? ",store.state.st_casos);
        },         
        bdRead(){

            // console.log("[culturaGlistado.js- bdRead], this.casos ? ",this.casos);
            // console.log("[culturaGlistado.js- bdRead], st_dbCasos ? ",store.state.st_dbCasos);
            var dummy= store.state.st_dbCasos
                        .on( 'value',snapshot=> this.getCasos( snapshot.val() ) );
        }, // bdRead()            
            bdReadMem(){
                
                // console.log("[bdReadMem], store.state.st_casos ? ",store.state.st_casos);
                this.getCasos(store.state.st_casos);

                // store.state.st_casos= this.losCasos;
                // console.log("[bdReadMem], casos ? ",this.casos);
            },
    }, // methods    
} // export



// WEBPACK FOOTER //
// ./src/components/culturaGlistado.js